/* ── Cart Drawer ──────────────────────────────────────── */
function openCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (!drawer || !overlay) return;
  drawer.classList.add('open');
  overlay.classList.remove('hidden');
  drawer.setAttribute('aria-hidden', 'false');
  refreshCart();
}

function closeCartDrawer() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-overlay');
  if (!drawer || !overlay) return;
  drawer.classList.remove('open');
  overlay.classList.add('hidden');
  drawer.setAttribute('aria-hidden', 'true');
}

function refreshCart() {
  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartCount(cart.item_count);
      renderCartDrawer(cart);
    })
    .catch(function(e) { console.error('Cart fetch error:', e); });
}

function updateCartCount(count) {
  document.querySelectorAll('#cart-count, #cart-drawer-count, .cart-count-badge').forEach(function(el) {
    if (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    }
  });
}

function renderCartDrawer(cart) {
  var itemsEl = document.getElementById('cart-drawer-items-list');
  var footerEl = document.getElementById('cart-drawer-footer');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');

  if (!itemsEl) return;

  // Update recommendations based on cart content
  var cartProductIds = [];
  if (cart && cart.items) {
    cartProductIds = cart.items.map(function(item) { return item.product_id; });
  }

  var recsListEl = document.querySelector('.cart-drawer__recommendations-list');
  var recsSection = document.querySelector('.cart-drawer__recommendations');
  if (recsSection && recsListEl) {
    if (cart.item_count === 0) {
      recsSection.style.display = 'none';
    } else {
      var firstProductId = cart.items[0].product_id;
      fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=5')
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data && data.products && data.products.length > 0) {
            var recHtml = '';
            var count = 0;
            data.products.forEach(function(product) {
              if (cartProductIds.indexOf(product.id) === -1 && count < 3) {
                var firstVariant = product.variants && product.variants[0];
                if (firstVariant && firstVariant.available) {
                  count++;
                  var priceFormatted = '₹' + (product.price / 100).toFixed(2);
                  recHtml += '<div class="cart-drawer-recommendation-item" data-product-id="' + product.id + '" style="display: flex; gap: 10px; align-items: center; background: #fff; border: 1px solid #eee; padding: 8px; border-radius: 8px;">' +
                    '<img src="' + product.featured_image + '" alt="' + escHtml(product.title) + '" style="width: 45px; height: 45px; object-fit: cover; border-radius: 4px; border: 1px solid #eee; flex-shrink: 0;" loading="lazy">' +
                    '<div style="flex: 1; min-width: 0;">' +
                      '<a href="' + product.url + '" class="cart-drawer-item__title" style="font-size: 11px; margin-bottom: 2px; display: block; text-decoration: none; color: #333; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">' + escHtml(product.title) + '</a>' +
                      '<span style="font-size: 11px; font-weight: 700; color: #1a472a;">' + priceFormatted + '</span>' +
                    '</div>' +
                    '<button type="button" class="btn btn-sm btn-success" onclick="quickAddToCart(' + firstVariant.id + ', this)" style="font-size: 10px; padding: 4px 8px; background: #1a472a; border: none; border-radius: 4px; font-weight: 600; white-space: nowrap; color: #fff;">Add</button>' +
                  '</div>';
                }
              }
            });

            if (count > 0) {
              recsListEl.innerHTML = recHtml;
              recsSection.style.display = 'block';
            } else {
              recsSection.style.display = 'none';
            }
          } else {
            recsSection.style.display = 'none';
          }
        })
        .catch(function(e) {
          console.error("Failed to load recommendations:", e);
          recsSection.style.display = 'none';
        });
    }
  }

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-drawer__empty"><svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Your cart is empty</p><a href="/collections/all" class="btn btn--primary btn--sm" onclick="closeCartDrawer()">Shop Now</a></div>';
    if (footerEl) footerEl.classList.add('is-hidden');
    return;
  }

  var html = cart.items.map(function(item) {
    return '<div class="cart-drawer-item">' +
      '<img src="' + item.image + '" alt="' + escHtml(item.title) + '" class="cart-drawer-item__img" loading="lazy">' +
      '<div class="cart-drawer-item__info">' +
        '<a href="' + item.url + '" class="cart-drawer-item__title" onclick="closeCartDrawer()">' + escHtml(item.product_title) + '</a>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer-item__qty" style="margin-bottom: 2px;">' + escHtml(item.variant_title) + '</p>' : '') +
        '<p class="cart-drawer-item__price" style="color: #1a472a; font-weight: 700; margin-bottom: 6px;">₹' + (item.line_price / 100).toFixed(2) + '</p>' +
        '<div class="cart-drawer-item__qty-wrapper" style="display:flex; align-items:center; gap:8px;">' +
          '<button type="button" class="cart-qty-btn" onclick="changeCartQty(\'' + item.key + '\', ' + (item.quantity - 1) + ')" style="padding:0; font-size:14px; border:1px solid #ccc; background:#fff; border-radius:4px; height:24px; width:24px; display:flex; align-items:center; justify-content:center; cursor:pointer; color:#555; font-weight:bold;">-</button>' +
          '<span class="cart-qty-val" style="font-size:13px; font-weight:600; min-width:18px; text-align:center; color:#333;">' + item.quantity + '</span>' +
          '<button type="button" class="cart-qty-btn" onclick="changeCartQty(\'' + item.key + '\', ' + (item.quantity + 1) + ')" style="padding:0; font-size:14px; border:1px solid #ccc; background:#fff; border-radius:4px; height:24px; width:24px; display:flex; align-items:center; justify-content:center; cursor:pointer; color:#555; font-weight:bold;">+</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }).join('');

  itemsEl.innerHTML = html;
  if (footerEl) footerEl.classList.remove('is-hidden');
  if (subtotalEl) subtotalEl.textContent = '₹' + (cart.total_price / 100).toFixed(2);
}

function changeCartQty(itemKey, newQty) {
  if (newQty < 0) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: itemKey, quantity: newQty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    updateCartCount(cart.item_count);
    renderCartDrawer(cart);
  })
  .catch(function(e) { console.error('Cart quantity change error:', e); });
}

function escHtml(str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/* ── Quick Add to Cart ────────────────────────────────── */
function quickAddToCart(variantId, btn) {
  if (!variantId) return;
  var orig = btn.innerHTML;
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.status) throw new Error(data.description || 'Could not add item');
    btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Added!';
    btn.classList.add('btn--added');
    refreshCart();
    openCartDrawer();
    setTimeout(function() {
      btn.disabled = false;
      btn.innerHTML = orig;
      btn.classList.remove('btn--added');
    }, 2000);
  })
  .catch(function(err) {
    btn.disabled = false;
    btn.innerHTML = orig;
    alert(err.message || 'Error adding to cart');
  });
}

/* ── Mobile Menu ──────────────────────────────────────── */
function toggleMobileMenu() {
  var menu = document.getElementById('mobile-menu');
  var btn = document.querySelector('.mobile-menu-toggle');
  var menuIcon = document.getElementById('menu-icon');
  var closeIcon = document.getElementById('close-icon');
  var isOpen = menu && menu.classList.toggle('open');
  if (btn) btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  if (menuIcon) menuIcon.style.display = isOpen ? 'none' : 'block';
  if (closeIcon) closeIcon.style.display = isOpen ? 'block' : 'none';
  if (menu) menu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
}

/* ── Search ───────────────────────────────────────────── */
function toggleSearch() {
  var bar = document.getElementById('search-bar');
  if (!bar) return;
  var isOpen = bar.classList.toggle('open');
  bar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  if (isOpen) {
    setTimeout(function() {
      var input = bar.querySelector('.header__search-input');
      if (input) input.focus();
    }, 100);
  }
}

/* ── Sticky Header shadow ─────────────────────────────── */
(function() {
  var header = document.getElementById('site-header');
  if (!header) return;
  window.addEventListener('scroll', function() {
    header.style.boxShadow = window.scrollY > 10 ? '0 4px 16px rgba(0,0,0,0.1)' : '';
  }, { passive: true });
})();

/* ── Init on DOMContentLoaded ─────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  refreshCart();

  // Close drawer on Escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.classList.contains('open')) closeCartDrawer();
      var searchBar = document.getElementById('search-bar');
      if (searchBar && searchBar.classList.contains('open')) toggleSearch();
    }
  });
});
